import React, {
  Fragment,
  useRef,
  useEffect,
  useState,
  useContext,
} from "react";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Button,
  Col,
  Row,
  Card,
  CardBody,
  ButtonGroup,
  Form,
  Label,
  Alert,
  Input,
  FormGroup,
  Tooltip,
} from "reactstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ButtonIcon from "../common/ButtonIcon";
import APICall from "../../services/apiCall";
import { toast } from "react-toastify";
import Loader from "../common/Loader";
import SikkaCardHeader from "../common/SikkaCardHeader";
import ModalCustom from "../common/ModalCustom";
import SikkaInput from "../common/SikkaInput";
import { useForm } from "react-hook-form";
import AuthService from "../../services/authenticationService";
import AppContext from "../../context/Context";
import ReactInputMask from "react-input-mask";
import SikkaError from "../common/SikkaError";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCircleCheck,
  faCircleXmark,
  faCopy,
  faLink,
  faSync,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import APIPortalTable from "../common/Table/APIPortalTable";
import TeamMemberStatusUpdateModal from "../ModalPopup/TeamMemberStatusUpdateModal";
import DeleteTeamMemember from "../ModalPopup/DeleteTeamMemember";
import apiCall from "../../services/apiCall";
import { Spinner } from "react-bootstrap";
import { validatePassword } from "../../helpers/utils";

const capitalize = (word) => {
  return word.charAt(0).toUpperCase() + word.substring(1);
};

const TeamMember = ({
  parent_devid,
  isActionAllowed,
  partnerDetails,
  setFetchPartnerDetails,
}) => {
  const [userList, setUserList] = useState([]);
  const [userListActive, setUserListActive] = useState([]);
  const [isUserListLoaded, setIsUserListLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openPopupManageTeamMember, setOpenPopupManageTeamMember] = useState(
    false
  );
  const [accessType, setAccessType] = useState("Revoke");
  const [userType, setUserType] = useState("admin");
  const [teamMemberData, setTeamMemberData] = useState([]);
  const [fetchData, setFetchData] = useState(false);
  const [showFilterSearch, setShowFilterSearch] = useState(false);
  const [filteredColumns, setFilteredColumns] = useState([]);
  const [showSuperAdminModal, setShowSuperAdminModal] = useState(false);
  const [
    selectedUserForNewSuperAdmin,
    setSelectedUserForNewSuperAdmin,
  ] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isReset2faModalOpen, setIsReset2faModalOpen] = useState(false);
  const [isReset2faLoading, setIsReset2faLoading] = useState(false);

  const [openStatusUpdateModal, setOpenStatusUpdateModal] = useState(false);
  const [
    isDeleteTeamMemberModelOpen,
    setIsDeleteTeamMemberModelOpen,
  ] = useState(false);
  const [generatedLink, setGeneratedLink] = useState("");
  const [isLinkGenerating, setIsLinkGenerating] = useState(false);
  const [isGeneratedLinkCopied, setIsGeneratedLinkCopied] = useState(false);

  const {
    register,
    handleSubmit,
    errors,
    watch,
    setError,
    clearError,reset
  } = useForm();

  const [selectedTeamMemberDetails, setSelectedTeamMemberDetails] = useState(
    {}
  );
  const [
    updateTeamMemberStatusValue,
    setUpdateTeamMemberStatusValue,
  ] = useState(selectedTeamMemberDetails?.dev_status);

  const { loginUserDetails, accessToken } = useContext(AppContext);

  const [defaultSeats, setDefaultSeats] = useState(5); // Default seats from API
  const [monthlyCost, setMonthlyCost] = useState(0); // Monthly cost from API
  const [modalLoader, setModalLoader] = useState(false);
  const [showModalContent, setShowModalContent] = useState(true); // Modal Content
  const [message, setMessage] = useState("");

  useEffect(() => {
    // get recovery questions
    if(partnerDetails?.parent_devid || partnerDetails?.devid){
        const params = {
        devid:partnerDetails?.parent_devid || partnerDetails?.devid
      };
      
      apiCall
        .servertrip("GET", "get_team_member_config", loginUserDetails, params)
        .then((res) => {
          if (res.data?.items?.length > 0) {
            setDefaultSeats(res.data.items[0].defaultSeats);
            setMonthlyCost(res.data.items[0].chargePerExtraSeat);
          } else {
            setDefaultSeats(5);
            setMonthlyCost(100);
          }
        })
        .catch((error) => {
          setDefaultSeats(5);
          setMonthlyCost(100);
        });
    }
  }, [partnerDetails?.parent_devid , partnerDetails?.devid]);
  
  const handleUserTypeUpdateClick = (data, currentUserType) => {
    setLoading(true);
    let userType;
    if (currentUserType !== data.user_type) {
      if (data.user_type === "Admin") {
        userType = "User";
      } else {
        userType = "Admin";
      }

      var body = {
        dev_id: data.devid,
        email_id: data.username,
        user_type: userType, // (value shold be Allow or Deny)
      };
      APICall.servertrip(
        "PUT",
        "api_user_access",
        loginUserDetails,
        undefined,
        body
      ).then(
        (res) => {
          setFetchData(true);
          setLoading(false);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.error(resMessage);
          setLoading(false);
        }
      );
    }
  };

  const accessTypeFormatter = ({ row, cell }) => {
    const data = row.original;

    if (
      (loginUserDetails.is_partner == "1" &&
        loginUserDetails?.dev_id !== row.original?.devid) ||
      loginUserDetails.is_partner == "0"
    ) {
      return (
        <>
          <ButtonGroup>
            <Button
              id="btnTeamMemberAccessTypeShow"
              data-devid={data.devid}
              data-emailid={data.username}
              data-type="full"
              data-oldtype={data.opt_flag}
              className={
                data.user_type.toLowerCase() === "admin"
                  ? "btn btn-xs btn-success"
                  : "btn btn-xs btn-secondary"
              }
              onClick={() => {
                setFetchData(false);
                handleUserTypeUpdateClick(data, "Admin");
              }}
            >
              Full
            </Button>
            <Button
              id="btnOffAc"
              data-devid={data.devid}
              data-emailid={data.username}
              data-type="full"
              data-oldtype={data.opt_flag}
              className={
                data.user_type.toLowerCase() === "user"
                  ? "btn btn-xs btn-danger"
                  : "btn btn-xs btn-secondary"
              }
              onClick={() => {
                setFetchData(false);
                handleUserTypeUpdateClick(data, "User");
              }}
            >
              Readonly
            </Button>
          </ButtonGroup>
        </>
      );
    }
    return <></>;
  };

  const handleRevokAccessClick = (data) => {
    setLoading(true);
    let accessType;
    if (data.access_type === "Allow") {
      accessType = "Deny";
    } else {
      accessType = "Allow";
    }

    var body = {
      dev_id: data.devid,
      email_id: data.username,
      access_type: accessType, // (value shold be Allow or Deny)
    };
    APICall.servertrip(
      "PUT",
      "api_user_access",
      loginUserDetails,
      undefined,
      body
    ).then(
      (res) => {
        setFetchData(true);
        setLoading(false);
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
        setLoading(false);
      }
    );
  };

  const handleEmailNotificationUpdateClick = (data) => {
    setLoading(true);
    const next = data.email_notification === "off" ? "on" : "off";

    var body = {
      dev_id: data.devid,
      email_id: data.username,
      email_notification: next,
    };
    APICall.servertrip(
      "PUT",
      "api_user_access",
      loginUserDetails,
      undefined,
      body
    ).then(
      (res) => {
        setFetchData(true);
        setLoading(false);
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
        setLoading(false);
      }
    );
  };

  const emailNotificationFormatter = ({ cell, row }) => {
    const data = row.original;
    const isOn = data.email_notification !== "off";
    return (
      <>
        {((loginUserDetails.is_partner == "1" &&
          loginUserDetails?.dev_id !== row.original?.devid) ||
          loginUserDetails.is_partner == "0") && (
          <>
            <ButtonGroup>
              <Button
                id="btnTeamMemberEmailNotificationOn"
                data-devid={data.devid}
                data-emailid={data.username}
                title="Enable Practice Location Email Notifications"
                className={
                  isOn ? "btn btn-xs btn-success" : "btn btn-xs btn-secondary"
                }
                onClick={() => {
                  if (!isOn) {
                    setFetchData(false);
                    handleEmailNotificationUpdateClick(data);
                  }
                }}
              >
                On
              </Button>
              <Button
                id="btnTeamMemberEmailNotificationOff"
                data-devid={data.devid}
                data-emailid={data.username}
                title="Disable Practice Location Email Notifications"
                className={
                  !isOn ? "btn btn-xs btn-danger" : "btn btn-xs btn-secondary"
                }
                onClick={() => {
                  if (isOn) {
                    setFetchData(false);
                    handleEmailNotificationUpdateClick(data);
                  }
                }}
              >
                Off
              </Button>
            </ButtonGroup>
          </>
        )}
      </>
    );
  };

  const loginAccessFormatter = ({ cell, row }) => {
    const data = row.original;
    return (
      <>
        {((loginUserDetails.is_partner == "1" &&
          loginUserDetails?.dev_id !== row.original?.devid) ||
          loginUserDetails.is_partner == "0") && (
          <>
            <Button
              id="btnTeamMemberLoginAccessShow"
              data-devid={data.devid}
              data-emailid={data.username}
              data-oldtype={data.opt_flag}
              className={
                data.access_type === "Deny"
                  ? "btn btn-xs btn-success"
                  : "btn btn-xs btn-danger"
              }
              onClick={() => {
                setFetchData(false);
                handleRevokAccessClick(data);
              }}
            >
              {btnLoading ? (
                <Loader size="sm" />
              ) : data.access_type === "Deny" ? (
                "Allow"
              ) : (
                "Revoke"
              )}
            </Button>
          </>
        )}
      </>
    );
  };

  const userTypeFormatter = ({ cell, row }) => {
    const data = row.original;
    return (
      <>
        <Button
          id="btnTeamMemberUserType"
          className="btn btn-xs btn-warning"
          onClick={() => {
            setShowSuperAdminModal(true);
            setSelectedUserForNewSuperAdmin(data);
          }}
        >
          Set as Super Admin
        </Button>
      </>
    );
  };
  const userStatusFormatter = ({ cell, row }) => {
    const data = row.original;
    return (
      <>
        {((loginUserDetails.is_partner == "1" &&
          loginUserDetails?.dev_id !== row.original?.devid) ||
          loginUserDetails.is_partner == "0") && (
          <>
            <ButtonGroup>
              <Button
                id="btnTeamMemberAccessTypeShow"
                className={
                  data.dev_status?.toLowerCase() === "active"
                    ? "btn btn-xs btn-success"
                    : "btn btn-xs btn-secondary"
                }
                onClick={() => {
                  if (data.dev_status.toLowerCase() !== "active") {
                    setSelectedTeamMemberDetails(data);
                    setOpenStatusUpdateModal(true);
                    setUpdateTeamMemberStatusValue("active");
                  }
                }}
              >
                Active
              </Button>
              <Button
                id="btnOffAc"
                className={
                  data.dev_status?.toLowerCase() === "inactive"
                    ? "btn btn-xs btn-danger"
                    : "btn btn-xs btn-secondary"
                }
                onClick={() => {
                  if (data.dev_status.toLowerCase() !== "inactive") {
                    setSelectedTeamMemberDetails(data);
                    setOpenStatusUpdateModal(true);
                    setUpdateTeamMemberStatusValue("inactive");
                  }
                }}
              >
                Inactive
              </Button>
            </ButtonGroup>
          </>
        )}
      </>
    );
  };

  const TwoFactorStatus = ({ cell, row }) => {
    const data = row.original;
    return (
      <>
        {data?.is_2fa_enabled?.toLowerCase() === "no" ? (
          <FontAwesomeIcon
            className="fa-2x"
            color="#E63757"
            icon={faCircleXmark}
          />
        ) : (
          <FontAwesomeIcon
            className="fa-2x"
            color="#00D27A"
            icon={faCircleCheck}
          />
        )}
      </>
    );
  };

  const handleReset2fa = () => {
    if (isReset2faLoading) return;
    const targetDevId = selectedTeamMemberDetails?.devid;
    if (!targetDevId) {
      toast.error("Invalid user. Please try again.");
      return;
    }
    setIsReset2faLoading(true);
    const apiParam = { dev_id: targetDevId };
    APICall.servertrip(
      "PUT",
      "reset_2fa",
      loginUserDetails,
      apiParam
    ).then(
      (res) => {
        toast.success(
          res?.data?.message ||
            "Two-factor authentication has been reset for the user."
        );
        setIsReset2faModalOpen(false);
        setIsRefresh((prev) => !prev);
        setIsReset2faLoading(false);
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
        setIsReset2faLoading(false);
      }
    );
  };

  const Reset2faFormatter = ({ cell, row }) => {
    const data = row.original;
    const is2faEnabled = data?.is_2fa_enabled?.toLowerCase() !== "no";
    if (loginUserDetails?.is_partner != "0" || !is2faEnabled) {
      return <></>;
    }
    return (
      <Button
        color="outline-danger"
        size="sm"
        title="Reset this user's two-factor authentication"
        onClick={() => {
          setSelectedTeamMemberDetails(data);
          setIsReset2faModalOpen(true);
        }}
      >
        <FontAwesomeIcon icon={faSync} className="mr-1" />
        Reset 2FA
      </Button>
    );
  };

  const columns = [
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "dev_name",
      header: "Name",
      Cell: ({ cell }) => {
        return (
          <span>
            {cell.getValue() !== "" || cell.getValue() !== undefined
              ? cell.getValue()
              : "--"}
          </span>
        );
      },
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "username",
      header: "Email",
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "dev_mobile",
      header: "Mobile",
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "access_type",
      header: "Login Access",
      Cell: loginAccessFormatter,
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "user_type",
      header: "Access Type",
      Cell: accessTypeFormatter,
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      accessorKey: "-",
      csvExport: false,
      header: "User Type",
      Cell: userTypeFormatter,
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      accessorKey: "dev_status",
      csvExport: true,
      header: "Status",
      Cell: userStatusFormatter,
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      accessorKey: "email_notification",
      csvExport: true,
      header: "Email Notifications",
      Cell: emailNotificationFormatter,
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      accessorKey: "is_2fa_enabled",
      csvExport: true,
      header: "2FA Status",
      Cell: TwoFactorStatus,
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        return "--";
      },
      sort: false,
      accessorKey: "reset_2fa",
      csvExport: false,
      header: "Reset 2FA",
      Cell: Reset2faFormatter,
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      accessorKey: "delete_mode",
      csvExport: true,
      header: "Member",
      Cell: ({ row, cell }) => {
        const rowDetails = row.original;
        return (
          <>
            {(loginUserDetails.dev_id !== rowDetails.devid &&
              loginUserDetails.is_partner == "1") ||
            loginUserDetails.is_partner == "0" ? (
              <Button
                color="danger"
                size="sm"
                className=""
                onClick={() => {
                  setIsDeleteTeamMemberModelOpen(true);
                  setSelectedTeamMemberDetails(rowDetails);
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            ) : (
              <></>
            )}
          </>
        );
      },
    },
  ];

  const filterColumns = (columns) => {
    if (
      (loginUserDetails.is_partner === "0" &&
        !isActionAllowed("liLogInAccessGridButtonAllowRevoke")) ||
      !loginUserDetails.is_partner === "1"
    ) {
      let idx = columns.findIndex((col) => col.header === "Login Access");
      columns.splice(idx, 1);
    }
    if (
      (loginUserDetails.is_partner === "0" &&
        !isActionAllowed("liAccessTypeGridButtonFullReadOnly")) ||
      !loginUserDetails.is_partner === "1"
    ) {
      let idx = columns.findIndex((col) => col.header === "Access Type");
      columns.splice(idx, 1);
    }
    if (
      (loginUserDetails.is_partner === "0" &&
        !isActionAllowed("liUserSetAsSuperAdminButton")) ||
      loginUserDetails.is_partner === "1"
    ) {
      let idx = columns.findIndex((col) => col.header === "User Type");
      columns.splice(idx, 1);
    }
    if (loginUserDetails.is_partner !== "0") {
      let idx = columns.findIndex((col) => col.header === "Reset 2FA");
      if (idx !== -1) {
        columns.splice(idx, 1);
      }
    }
    return columns;
  };

  useEffect(() => {
    setFilteredColumns(filterColumns(columns));
  }, []);

  useEffect(() => {
    if (parent_devid || fetchData || isRefresh) {
      setLoading(true);
      setIsUserListLoaded(false);
      var apiParam = {
        parent_devid: parent_devid,
        is_partner: "1",
        sort_by: "dev_name",
        sort_order: "asc",
        user_dev_id: loginUserDetails.dev_id,
      };
      APICall.servertrip(
        "GET",
        "partner_details_user",
        loginUserDetails,
        apiParam
      ).then(
        (res) => {
          const teamMembers = Array.isArray(res?.data?.items)
            ? res.data.items
            : [];
          setUserList(teamMembers);
          setLoading(false);
          setIsUserListLoaded(true);
          setUserListActive(
            teamMembers.filter(
              (item) =>
                item?.dev_status === "Active" || item?.dev_status === "active"
            )
          );
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          setLoading(false);
          toast.error(resMessage);
          setIsUserListLoaded(false);
        }
      );
    }
  }, [parent_devid, fetchData, isRefresh]);

  const handleAddingTeamMember = (values) => {
    // setFetchData(true);
    const getValuesKeys = Object.keys(values);
    const onlyWhiteSpcaedValue = getValuesKeys.filter((item) => {
      if (!values[item].trim()) {
        return values[item];
      }
    });
    if (onlyWhiteSpcaedValue.length > 0) {
      onlyWhiteSpcaedValue.forEach((item) => {
        setError(item, "custom", `${capitalize(item)} is required.`);
      });
    } else {
      clearError();
      setTeamMemberData(values);
      // setOpenPopupManageTeamMember(false);

      let mobileNo = values.mobileNo
        .split("")
        .filter((data) => {
          return data >= "0" && data <= "9";
        })
        .join("");
      //Team
      const teamMemberbody = {
        username: values.email,
        password: values.password,
        devid: "",
        dev_name: values.fullName,
        dev_address: values.address,
        dev_phone: mobileNo,
        dev_mobile: mobileNo,
        dev_city: values.city,
        dev_state: values.state,
        dev_country: values.country,
        dev_zip: values.zipCode,
        user_type: userType, // [User for readonly and Admin for full access]
        plan_id: partnerDetails.plan_id, // [parent plan id]
        sla_plan_id: partnerDetails.sla_pan_id, // [parent sla_plan_id]
        parent_devid: parent_devid, // [parent dev id]
        partner_name: partnerDetails?.partner_name,
        add_updated_by: loginUserDetails?.user_name,
        page_type: "add_team_member",
      };
      if (
        loginUserDetails.is_partner == "1" ||
        loginUserDetails.is_partner == "0"
      ) {
        setModalLoader(true);
        AuthService.addTeamMember(teamMemberbody).then(
          (res) => {
            setFetchData(true);
            setModalLoader(false);
            setShowModalContent(false);
            // setMessage("Team member successfully added!");
            toast.success("Team member successfully added");
            reset();
            setOpenPopupManageTeamMember(false);
          },
          (error) => {
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
            toast.error(resMessage);
            setModalLoader(false);
            setShowModalContent(true);
            setFetchData(false);
          }
        );
      } else {
        setOpenPopupManageTeamMember(true);
      }
    }

    //Access type PUT
    // var body = {
    //   dev_id: parent_devid,
    //   email_id: values.email,
    //   access_type: "Deny", // (value shold be Allow or Deny)
    // };
    // APICall.servertrip("PUT", "api_user_access", undefined, body).then(
    //   (res) => {},
    //   (error) => {
    //     const resMessage =
    //       (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    //     toast.error(resMessage);
    //   }
    // );
  };

  const handleSetSuperAdmin = (values) => {
    setLoading(true);
    setFetchData(false);
    setFetchPartnerDetails(false);
    setShowSuperAdminModal(false);
    const body = {
      super_admin_email_id: partnerDetails.username, //existing super admin email id
      new_super_admin_email_id: selectedUserForNewSuperAdmin.username,
      partner_name: selectedUserForNewSuperAdmin.partner_name,
      comment: values.comment,
      add_updated_by: values.updatedBy,
      user_dev_id: loginUserDetails.dev_id,
    };
    APICall.servertrip(
      "PUT",
      "user_type",
      loginUserDetails,
      undefined,
      body
    ).then(
      (res) => {
        setFetchData(true);
        setFetchPartnerDetails(true);
        setLoading(false);
        toast.success("Super Admin successfully changed");
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
        setLoading(false);
      }
    );
  };

  const MyExportCSV = (props) => {
    const handleClick = () => {
      // passing my custom data
      if (userList?.length > 0) {
        // if (table.current.paginationContext.props.data.length > 0) {
        //   if (table.current.sortContext.state.sortOrder) {
        //     props.onExport(table.current.paginationContext.props.data);
        //   } else {
        //     props.onExport();
        //   }
        // } else {
        //   toast.error("No Record Found.");
        // }
      } else {
        toast.error("No Record Found.");
      }
    };
    return (
      <ButtonIcon
        color="falcon-success"
        size="sm"
        icon="download"
        className="ml-1 mt-lg-0 mb-2"
        iconClassName="fs--2"
        onClick={handleClick}
      >
        .CSV
      </ButtonIcon>
    );
  };

  const FetchGenerateLink = () => {
    setIsLinkGenerating(true);
    setGeneratedLink("");
    setIsGeneratedLinkCopied(false);

    let apiParam = {
      devId: parent_devid,
    };

    if (parent_devid) {
      APICall.servertrip(
        "GET",
        "get_team_member_link",
        loginUserDetails,
        apiParam
      ).then(
        (res) => {
          const response = res.data?.items;
          setIsLinkGenerating(false);
          setGeneratedLink(`${response?.q}&t=${response?.t}`);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          setGeneratedLink("");
          setIsLinkGenerating(false);
          toast.error(resMessage);
        }
      );
    } else {
      setGeneratedLink("");
      setIsLinkGenerating(false);
      setIsGeneratedLinkCopied(false);
      toast.error("Dev ID should not be empty.");
    }
  };

  useEffect(() => {
    if (userList?.length >= 5 && loginUserDetails.is_partner == "1") {
    } else {
      if (isUserListLoaded && parent_devid) {
        FetchGenerateLink();
      }
    }
  }, [parent_devid, isUserListLoaded]);

  return (
    <Fragment>
      <Card className="mb-3">
        <div>
          <SikkaCardHeader title="Team Member(s) List" light={true}>
            <div className="d-flex mt-2 flex-wrap">
              <ButtonIcon
                color="outline-primary"
                size="sm"
                icon="Sync"
                className="ml-1 mt-lg-0 mb-2"
                iconClassName="fs--2"
                onClick={() => {
                  setIsRefresh(!isRefresh);
                }}
              >
                <FontAwesomeIcon style={{ marginRight: "5px" }} icon={faSync} />
                Refresh
              </ButtonIcon>
              {/* liTeamMemberGenerateLink */}
              {loginUserDetails.is_partner == "1" ||
              (loginUserDetails.is_partner == "0" &&
                isActionAllowed("liTeamMemberGenerateLink")) ? (
                <>
                  <ButtonIcon
                    color="outline-primary"
                    size="sm"
                    id="team-member-invite-link"
                    icon="Sync"
                    className="ml-1 mt-lg-0 mb-2 d-flex align-items-center"
                    iconClassName="fs--2"
                    onClick={() => {
                      // if (
                      //   userList.length >= 5 &&
                      //   loginUserDetails.is_partner == "1"
                      // ) {
                      //   toast.error(
                      //     "You can't invite more than 5 team members."
                      //   );
                      // } else {
                      setIsGeneratedLinkCopied(true);
                      let teamMemberLink = `${window.location.origin}${
                        process.env.PUBLIC_URL
                      }/authentication/register?q=${generatedLink}`;
                      navigator.clipboard.writeText(teamMemberLink);
                      setTimeout(() => {
                        setIsGeneratedLinkCopied(false);
                      }, 3000);

                      userListActive?.length >= defaultSeats &&
                        toast.warn(
                          "Adding more than " +
                            defaultSeats +
                            " seats will cost extra $" +
                            monthlyCost +
                            " per user per month"
                        );
                      // }
                    }}
                    disabled={isLinkGenerating}
                  >
                    {isLinkGenerating ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm mr-2 ml-2"
                          style={{ opacity: "0.5" }}
                          role="status"
                          aria-hidden="true"
                        />
                      </>
                    ) : (
                      <>
                        <FontAwesomeIcon
                          style={{ marginRight: "5px" }}
                          icon={faLink}
                        />
                      </>
                    )}
                    Invite Link
                    <Tooltip
                      placement="top"
                      isOpen={isGeneratedLinkCopied}
                      target="team-member-invite-link"
                      trigger="click"
                    >
                      Copied
                    </Tooltip>
                  </ButtonIcon>
                </>
              ) : (
                <></>
              )}

              {loginUserDetails.is_partner === "1" ||
              (loginUserDetails.is_partner === "0" &&
                isActionAllowed("liAddTeamMemberButton")) ? (
                userList?.length === 0 || userList?.length > 0 ? (
                  <ButtonIcon
                    icon="plus"
                    transform="shrink-3 down-2"
                    color="outline-primary"
                    size="sm"
                    className="mx-1 mb-2"
                    onClick={(e) => {
                      // if (
                      //   userList.length >= 5 &&
                      //   loginUserDetails.is_partner == "1"
                      // ) {
                      //   toast.error("You can't add more than 5 team members.");
                      // } else {
                      //   setOpenPopupManageTeamMember(true);
                      // }
                      setOpenPopupManageTeamMember(true);
                    }}
                  >
                    Team Member
                  </ButtonIcon>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
            </div>
          </SikkaCardHeader>

          <CardBody className="p-0">
            <div className="table-responsive-lg">
              <APIPortalTable
                data={userList}
                columns={filteredColumns}
                loading={loading}
                enablePagination
                CSVFileName={`${
                  partnerDetails.partner_name
                }_Team_member(s)_List_${new Date().getMonth() +
                  1}/${new Date().getDate()}/${new Date().getFullYear()}.csv`}
              />
            </div>
          </CardBody>
        </div>
      </Card>

      <ModalCustom
        title="Manage Team Member"
        openPopup={openPopupManageTeamMember}
        setOpenPopup={setOpenPopupManageTeamMember}
        size="lg"
      >
        <Row />
        <Form onSubmit={handleSubmit(handleAddingTeamMember)}>
          <>
            {modalLoader ? (
              <>
                <Row>
                  <Col className="d-flex justify-content-center">
                    <Spinner animation="border" />
                  </Col>
                </Row>
              </>
            ) : (
              <>
                <Row>
                  <Col>
                    <SikkaInput
                      label="Full Name*"
                      name="fullName"
                      id="fullName"
                      placeholder="Full Name"
                      innerRef={register({
                        required: "Full Name is required",
                      })}
                      errors={errors}
                    />
                  </Col>
                  <Col>
                    <SikkaInput
                      type="email"
                      label="Email*"
                      placeholder="Email"
                      name="email"
                      id="email"
                      innerRef={register({
                        required: "Email is required",
                        pattern: {
                          value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                          message: "Email must be valid",
                        },
                      })}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <SikkaInput
                      type="password"
                      label="Password*"
                      name="password"
                      placeholder="Password"
                      id="password"
                      innerRef={register({
                        required: "You must specify a password",
                        minLength: {
                          value: 9,
                          message: "Password must have at least 9 characters",
                        },
                        validate: (value) => {
                          return validatePassword(value).length > 0
                            ? validatePassword(value)[0]
                            : true;
                        },
                        // pattern: {
                        //   value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,15}$/,
                        //   message:
                        //     "Password must be contain one uppercase Letter",
                        // },
                      })}
                      errors={errors}
                    />
                  </Col>
                  <Col>
                    <SikkaInput
                      type="password"
                      label="Confirm Password*"
                      name="confirmPassword"
                      placeholder="Confirm Password"
                      id="confirmPassword"
                      innerRef={register({
                        required: "Confirm Password field is required",
                        validate: (value) =>
                          value === watch("password") ||
                          "Password doesn't match",
                      })}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <SikkaInput
                      label="Address*"
                      name="address"
                      id="address"
                      placeholder="Address"
                      innerRef={register({
                        required: "Address is required",
                      })}
                      errors={errors}
                    />
                  </Col>

                  <Col>
                    <FormGroup>
                      <Label for={"mobileNo"}>
                        {"Mobile Number*".slice(0, -1)}
                        <span style={{ color: "#e63757", marginLeft: "3px" }}>
                          *
                        </span>
                      </Label>

                      <Input
                        type="tel"
                        mask="(999)-999-9999"
                        maskChar=" "
                        size="sm"
                        placeholder="Mobile Number"
                        name="mobileNo"
                        id="mobileNo"
                        inputRef={register({
                          required: "Mobile number is required",
                          pattern: {
                            value: /^[^\s]+(\s+[^\s]+)*$/,
                            message: "Invalid Mobile Number",
                          },
                        })}
                        className={classNames("fs--1", {
                          "border-danger": errors["mobileNo"]?.message,
                        })}
                        tag={ReactInputMask}
                      />
                      <SikkaError
                        error={errors["mobileNo"]?.message}
                        className="mt-1"
                      />
                    </FormGroup>
                  </Col>

                  {/* <Col>
              <FormGroup>
                {"Mobile No.*" && "Mobile No.*".includes("*") ? (
                  <Label for={"mobileNo"}>
                    {"Mobile No.*".slice(0, -1)}
                    <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
                  </Label>
                ) : (
                  <Label for={"mobileNo"}>{"Mobile No.*"}</Label>
                )}
                <Input
                  type="tel"
                  mask="(999)-999-9999"
                  maskChar=" "
                  size="sm"
                  placeholder="Mobile No."
                  name="mobile"
                  id="mobile"
                  inputRef={register({ required: "Mobile is required" })}
                  // innerRef={register({
                  //   required: "Mobile is required",
                  // })}
                  className={classNames("fs--1", { "border-danger": errors["mobile"]?.message })}
                  tag={ReactInputMask}
                />
                <SikkaError error={errors["mobile"]?.message} className="mt-1" />
              </FormGroup>
              </Col> */}
                  {/* <SikkaInput
                label="Mobile No.*"
                customType="phone"
                placeholder="Mobile No"
                name="mobileNo"
                id="mobileNo"
                onChange={(e) => setMobileNo(e.target.value)}
                innerRef={register({
                  required: "Mobile No. is required",
                })}
                errors={errors}
              /> */}
                </Row>
                <Row>
                  <Col>
                    <SikkaInput
                      type="select"
                      label="Country*"
                      name="country"
                      size="sm"
                      id="country"
                      placeholder="Country"
                      options={[
                        { key: "Australia", value: "Australia" },
                        { key: "Canada", value: "Canada" },
                        { key: "India", value: "India" },
                        { key: "United States", value: "United States" },
                      ]}
                      className="input-spin-none fs--1"
                      innerRef={register({
                        required: "Country is required",
                      })}
                      errors={errors}
                    />
                  </Col>
                  <Col>
                    <SikkaInput
                      label="State*"
                      name="state"
                      id="state"
                      placeholder="State"
                      innerRef={register({
                        required: "State is required",
                      })}
                      errors={errors}
                    />
                  </Col>
                  <Col>
                    <SikkaInput
                      label="City*"
                      name="city"
                      id="city"
                      placeholder="City"
                      innerRef={register({
                        required: "City is required",
                      })}
                      errors={errors}
                    />
                  </Col>
                  <Col>
                    <SikkaInput
                      label="Zip Code*"
                      placeholder="Zip Code"
                      name="zipCode"
                      id="zipCode"
                      innerRef={register({
                        required: "Zip Code is required",
                        validate: (value) => {
                          const selectedCountry = watch("country");

                          if (!/^[A-Za-z0-9\s-]*$/.test(value)) {
                            return "Special characters are not allowed";
                          }
                          switch (selectedCountry) {
                            case "United States":
                              return (
                                /^\d{5}(-\d{4})?$/.test(value) ||
                                "US zipcode must be 5 digits or 5 digits followed by hyphen and 4 digits"
                              );

                            case "Canada":
                              return (
                                /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/.test(
                                  value
                                ) ||
                                "Canadian postal code must be in format: A1A 1A1"
                              );

                            case "India":
                              return (
                                /^[1-9][0-9]{5}$/.test(value) ||
                                "Indian pincode must be 6 digits"
                              );

                            case "Australia":
                              return (
                                /^\d{4}$/.test(value) ||
                                "Australian postcode must be 4 digits"
                              );

                            default:
                              return "Please select a country first";
                          }
                        },
                      })}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col className="d-flex align-items-baseline">
                    <Label for="fullAccess" className="mr-2">
                      Access Type{" "}
                      <span style={{ color: "#e63757", marginLeft: "3px" }}>
                        *
                      </span>
                    </Label>
                    <ButtonGroup>
                      <Button
                        size="sm"
                        className={
                          userType.toLowerCase() === "admin"
                            ? "btn btn-sm btn-success"
                            : "btn btn-sm btn-secondary"
                        }
                        onClick={() => {
                          setUserType("Admin");
                        }}
                      >
                        Full
                      </Button>
                      <Button
                        className={
                          userType.toLowerCase() === "user"
                            ? "btn btn-sm btn-danger"
                            : "btn btn-sm btn-secondary"
                        }
                        onClick={() => {
                          setUserType("User");
                        }}
                      >
                        Readonly
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>

                {userListActive?.length >= defaultSeats && (
                  <div className="">
                    <Alert color="primary">
                      Adding additional seats beyond {defaultSeats} will incur
                      an extra ${monthlyCost} per user per month.
                    </Alert>
                  </div>
                )}

                <Row
                  className="modal-footer px-md-3 bg-light"
                  style={{
                    marginLeft: "-16px",
                    marginRight: "-16px",
                    marginBottom: "-16px",
                  }}
                >
                  <Button
                    color="outline-primary"
                    size="sm"
                    className="ml-auto"
                    type="submit"
                  >
                    Save
                  </Button>
                  <Button
                    size="sm"
                    color="outline-danger"
                    onClick={() => {
                      setOpenPopupManageTeamMember(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Row>
              </>
            )}
          </>
        </Form>
      </ModalCustom>

      <ModalCustom
        title="Add Comment"
        openPopup={showSuperAdminModal}
        setOpenPopup={setShowSuperAdminModal}
        size="lg"
      >
        <Form onSubmit={handleSubmit(handleSetSuperAdmin)}>
          <Row>
            <Col>
              <SikkaInput
                label="Updated By"
                value={loginUserDetails.user_name}
                name="updatedBy"
                id="updatedBy"
                disabled
                innerRef={register({
                  required: "Zip Code is required",
                })}
                errors={errors}
              />
              <SikkaInput
                label="Comment"
                name="comment"
                id="SetSuperAdminComment"
                innerRef={register({
                  required: "Comment is required",
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid comment",
                  },
                })}
                errors={errors}
              />
            </Col>
          </Row>
          <Row
            className="modal-footer px-md-3 bg-light"
            style={{
              marginLeft: "-16px",
              marginRight: "-16px",
              marginBottom: "-16px",
            }}
          >
            <Button
              color="outline-primary"
              size="sm"
              className="ml-auto"
              type="submit"
            >
              Submit
            </Button>
            <Button
              size="sm"
              color="outline-secondary"
              onClick={() => {
                setShowSuperAdminModal(false);
              }}
            >
              Cancel
            </Button>
          </Row>
        </Form>
      </ModalCustom>

      <ModalCustom
        title="Add comment"
        openPopup={openStatusUpdateModal}
        setOpenPopup={setOpenStatusUpdateModal}
        size="md"
      >
        <TeamMemberStatusUpdateModal
          partnerDetailsData={selectedTeamMemberDetails}
          setOpenStatusUpdateModal={setOpenStatusUpdateModal}
          // setFetchPartnerDetails={setFetchPartnerDetails}
          // setFetchApplicationDetails={setFetchApplicationDetails}
          updateTeamMemberStatusValue={updateTeamMemberStatusValue}
          setIsRefresh={setIsRefresh}
          userListActive={userListActive}
        />
      </ModalCustom>
      <ModalCustom
        title="Delete Team Member"
        openPopup={isDeleteTeamMemberModelOpen}
        setOpenPopup={setIsDeleteTeamMemberModelOpen}
        size="md"
      >
        <DeleteTeamMemember
          openPopup={isDeleteTeamMemberModelOpen}
          setOpenPopup={setIsDeleteTeamMemberModelOpen}
          setIsRefresh={setIsRefresh}
          selectedTeamMember={selectedTeamMemberDetails}
        />
      </ModalCustom>
      <ModalCustom
        title="Reset Two Factor Authentication"
        openPopup={isReset2faModalOpen}
        setOpenPopup={setIsReset2faModalOpen}
        size="md"
        centered
        fade={false}
      >
        <Alert color="warning" className="fs--1">
          Are you sure you want to reset two-factor authentication for{" "}
          <b>{selectedTeamMemberDetails?.username || "this user"}</b>? This will
          disable their 2FA and clear their account recovery questions. They
          will be required to set up 2FA and recovery questions again on their
          next login.
        </Alert>
        <Row>
          <Col className="text-right">
            <Button
              color="secondary"
              size="sm"
              className="mr-2"
              type="button"
              disabled={isReset2faLoading}
              onClick={() => setIsReset2faModalOpen(false)}
            >
              Cancel
            </Button>
            <Button
              color="danger"
              size="sm"
              type="button"
              disabled={isReset2faLoading}
              onClick={handleReset2fa}
            >
              {isReset2faLoading ? "Resetting..." : "Reset 2FA"}
            </Button>
          </Col>
        </Row>
      </ModalCustom>
    </Fragment>
  );
};

export default TeamMember;
